module.exports = __webpack_public_path__ + "static/media/vf-button-pants-black.87e445ca.svg";